import {useQuery} from 'react-query';

import {getAllComments} from '.';

const useGetAllComments = (guid?: string, currentPage?: number) => {
  const {data, isLoading} = useQuery(
    ['get-offers', guid, currentPage],
    getAllComments,
  );

  return {data, isLoading};
};

export default useGetAllComments;
